import React, { Component } from "react"
import { connect } from "react-redux"
import cookie from "react-cookies"

import { Spin, Row, Col, Button } from "antd"
import { error_manager } from "helper/error_manager"
import { loadUsers } from "redux_actions/cases.action"
import AddCasesToFolderModal from "component/patientfolder/AddCasesToFolderModal"
import { openEndPoint } from "utils/utils"
import HistoryLink from "component/common/HistoryLink"

import CaseTable from "component/patientfolder/case/CaseTable"
import "asset/style/dashboard.css"
import "asset/style/patient_folder.css"
import CaseInfo from "component/patientfolder/case/CaseInfo"
import CreateAndSearchBar from "component/patientfolder/CreateAndSearchBar"
import { getFolderEndpoint } from "utils/endpoint_utils"
import { aclPermissions, hasPermissions } from "const/ACLPermissions"
import { getUnauthorizedComponent } from "component/dashboard/slidelist_utils"
import { get } from "helper/request"


class PatientFolder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isFetching: true,
            isFetchingCases: true,
            folderName: "",
            folderId: "",
            createdOn: null,
            updatedOn: null,
            createdBy: null,
            tags: [],
            cases: [],
            showAddCaseModal: false,
            searchCaseId: [],
        }

        this.folderId = this.props.match.params.id
    }

    componentDidMount() {
        this.fetchFolderInfo()

        this.props.dispatch(loadUsers())
    }

    componentWillUnmount() {
    }

    fetchFolderInfo() {
        const id = this.props.match.params.id
        const url = `/api/patient_folder/${id}/`

        get(url)
            .then(data => {
                const folderId = data?.["id"]
                const folderName = data?.["folder_name"]
                const createdOn = data?.["created_on"]
                const createdBy = data?.["created_by"]
                const tags = data?.["tags"]?.map(({ name }) => name)
                const cases = data?.["cases"]

                this.setState({
                    folderId,
                    folderName,
                    createdOn,
                    createdBy,
                    tags,
                    cases,
                })
            })
            .catch(err => {
                console.error(err.message)
                error_manager("Unable to fetch folder", err)
            })
            .finally(() => this.setState({ "isFetching": false }))
    }

    handleAddCase = () => this.setState({ showAddCaseModal: true })

    historyLinks = () => ([
        {
            label: "Folders",
            link: getFolderEndpoint()
        },
        {
            label: this.state.folderName,
            link: `/patient_folder/${this.state.folderId}`
        },
    ])

    handleCreate = () => openEndPoint("/addcase/")

    handleSearch = (value) => {
        if (!value || this.state.searchCaseId.includes(value)) return
        this.setState(state => ({ ...state, searchCaseId: [...state.searchCaseId, value] }))
    }

    handleReset = () => {
        this.setState({ searchCaseId: [] })
    }

    handleDeselect = (value) => {
        this.setState(state =>  ({ ...state, searchCaseId: state.searchCaseId.filter(v => v !== value) }))
    }

    applySearchCaseFilter = () => {
        if (this.state.searchCaseId.length < 1) return this.state.cases
        return this.state.cases.filter(({ case_id }) => this.state.searchCaseId.reduce((p, c) => p || case_id?.startsWith(c), false))
    }

    render() {
        if (!hasPermissions([aclPermissions.folders_menu])) {
            return getUnauthorizedComponent()
        }

        return this.state.isFetching ? <Spin spinning={true} /> : (
            <div className="patient-folder-wrapper">
                <HistoryLink links={this.historyLinks()} />

                <Row type="flex" gutter={16}>
                    <Col span={24}>
                        <CaseInfo {...this.state} />
                    </Col>
                    <Col span={24} className="col-div">
                        <CaseTableHeading handleAddCase={this.handleAddCase} />
                    </Col>
                    <Col span={24} className="col-div">
                        <CreateAndSearchBar
                            title={"Case"}
                            searchSelected={this.state.searchCaseId}
                            handleCreate={this.handleCreate}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                            handleDeselect={this.handleDeselect}
                        />
                    </Col>
                    <Col span={24} className="col-div">
                        <CaseTable cases={this.applySearchCaseFilter()} folderId={this.state.folderId} />
                    </Col>
                </Row>

                {this.state.showAddCaseModal ?
                    <AddCasesToFolderModal
                        folderId={this.state.folderId}
                        showModal={this.state.showAddCaseModal}
                        closeModal={() => this.setState({ showAddCaseModal: false })}
                    />
                    : <></>
                }
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    allUsers: state.caseStatusReducer.users,
    urlState: state.searchCaseReducer,
})

export default connect(mapStateToProps)(PatientFolder)


class CaseTableHeading extends Component {
    constructor(props) {
        super(props)

        this.hasPermission = hasPermissions([aclPermissions.case_info_app])
    }

    render() {
        return (
            <div className="main-heading-wrapper">
                <Row>
                    <Col span={2} className="main-heading">
                        <b>Cases</b>
                    </Col>
                    <Col span={3}>
                        {this.hasPermission ?
                            <Button onClick={this.props.handleAddCase}>Add Case to Folder</Button>
                            : <></>
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}